import { ReactElement } from 'react';
import { MatchCardInlineUSASkeleton } from 'components/Shared/MatchCardInlineUSA/__partials/Skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

type Props = {
  sportAlias?: string;
  showTitle?: boolean;
  detailedTeamsInfo?: boolean;
};

export const USALayoutSkeleton = ({
  sportAlias,
  showTitle = true,
  detailedTeamsInfo
}: Props): ReactElement => {
  return (
    <div style={{ borderBottom: '4px solid var(--v3-black-6)' }}>
      {showTitle && (
        <div className="USALayoutSkeleton">
          <div className="USALayoutSkeleton__title">
            <Skeleton
              title={{ style: { width: 100, margin: 0, height: 10 } }}
              paragraph={false}
              active
            />
          </div>
          {!detailedTeamsInfo && (
            <Skeleton
              title={{
                style: { width: 20, margin: 0, height: 10, marginLeft: '90%' }
              }}
              paragraph={false}
              active
            />
          )}
        </div>
      )}
      <MatchCardInlineUSASkeleton
        sportAlias={sportAlias}
        detailedTeamsInfo={detailedTeamsInfo}
      />
    </div>
  );
};
